/** Kế hoạch điều trị dùng chung mọi chuyên khoa (#18736). */
import { apiClient } from "./client";

export interface TreatmentPlanItem {
  id: string;
  description: string;
  sessionNo: number | null;
  status: "PLANNED" | "COMPLETED" | "SKIPPED";
  serviceId: string | null;
  doneAt: string | null;
}

export interface TreatmentPlan {
  id: string;
  title: string;
  status: "DRAFT" | "ACTIVE" | "COMPLETED" | "CANCELLED";
  /** DENTAL / GENERAL — which screen authored it. Dental plans are read-only here. */
  vertical: string | null;
  note: string | null;
  createdAt: string;
  totalItems: number;
  doneItems: number;
  items: TreatmentPlanItem[];
}

export const treatmentPlanQueryKeys = {
  forPatient: (patientId: string) => ["treatment-plans", patientId] as const,
};

export const treatmentPlansApi = {
  /** Every plan for the patient, dental included — a doctor wants the whole picture. */
  forPatient: (patientId: string) =>
    apiClient
      .get<TreatmentPlan[]>(`/v1/patients/${patientId}/treatment-plans`)
      .then((r) => r.data),

  create: (patientId: string, title: string, note?: string | null) =>
    apiClient
      .post<{ id: string }>(`/v1/patients/${patientId}/treatment-plans`, { title, note })
      .then((r) => r.data),

  addItem: (planId: string, description: string, sessionNo?: number | null) =>
    apiClient
      .post<{ id: string }>(`/v1/treatment-plans/${planId}/items`, { description, sessionNo })
      .then((r) => r.data),

  completeItem: (itemId: string) =>
    apiClient
      .post<void>(`/v1/treatment-plan-items/${itemId}/complete`)
      .then(() => undefined),

  setStatus: (planId: string, status: TreatmentPlan["status"]) =>
    apiClient
      .put<void>(`/v1/treatment-plans/${planId}/status`, null, { params: { status } })
      .then(() => undefined),
};

export const PLAN_STATUS_LABELS: Record<TreatmentPlan["status"], string> = {
  DRAFT: "Nháp",
  ACTIVE: "Đang điều trị",
  COMPLETED: "Hoàn tất",
  CANCELLED: "Đã huỷ",
};
